import { fromJS, Map } from 'immutable';

const NAME_SPACE = 'LEGDER/SUPPLIER/';

const initialState = new Map({
  'loading': true,
  'currency': [],
  'ledger': {
    'data': [],
    'pageSize': 0,
    'currentPage': 0,
    'count': 0,
  }
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'EDIT_SUPPLIER_GENERAL_LEDGER':
      return state.update('ledger', ledger => {
        return ledger.update('data', data => {
          return data.update(data.findIndex(x => x.get('sgl_id') === action.payload.o.sgl_id), o => {
            return o.merge(action.payload.o);
          });
        });
      });
    case NAME_SPACE + 'RECEIVE_SUPPLIER_GENERALLEDGER_COLLECTION':
      return fromJS(action.payload.Collection);
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'EDIT_SUPPLIER_GENERAL_LEDGER':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_SUPPLIER_GENERALLEDGER_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};